import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createVNode("ion-icon", { name: "document-text-outline" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Download Template ")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("small", null, "Template yang sama dapat digunakan untuk kedua operasi", -1)
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "card h-100" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "import-file" }, "Import Excel VA Orders", -1)
const _hoisted_12 = { class: "row py-2" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "my-1" }, "Tagihan yang digunakan :", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: 0 }, "Pilih Tagihan", -1)
const _hoisted_16 = { class: "input-group my-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("ion-icon", { name: "cloud-upload-outline" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Mulai Impor")
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "card h-100" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "import-file-expired" }, "Import Excel Expired VA", -1)
const _hoisted_24 = { class: "row py-2" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "my-1" }, "Tagihan yang digunakan :", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: 0 }, "Pilih Tagihan", -1)
const _hoisted_28 = { class: "input-group my-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("ion-icon", { name: "cloud-upload-outline" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Mulai Impor")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Impor VA",
      link1: "Impor VA"
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.canRead)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadTemplate()))
            }, [
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        _hoisted_5,
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected_bill = $event)),
                  class: "text-primary form-select"
                }, [
                  _hoisted_15,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bill_options, (bill, id) => {
                    return (_openBlock(), _createBlock("option", {
                      key: bill.id,
                      label: bill.name,
                      value: bill.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selected_bill]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("input", {
                type: "file",
                class: "form-control",
                id: "import-file",
                ref: "va_file",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleVAFileUpload()))
              }, null, 544),
              (_ctx.canCreate)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn btn-outline-secondary",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.importFile('va_file')))
                  }, [
                    _hoisted_17,
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selected_bill2 = $event)),
                  class: "text-primary form-select"
                }, [
                  _hoisted_27,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bill_options, (bill, id) => {
                    return (_openBlock(), _createBlock("option", {
                      key: bill.id,
                      label: bill.name,
                      value: bill.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selected_bill2]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("input", {
                type: "file",
                class: "form-control",
                id: "import-file-expired",
                ref: "expired_file",
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleExpireFileUpload()))
              }, null, 544),
              (_ctx.canCreate)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn btn-outline-secondary",
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.importFile('expired_file')))
                  }, [
                    _hoisted_29,
                    _hoisted_30
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}